module.exports = {
  eventCategory: 'Editor UI | Tool Menu | search',

  show: { eventAction: 'show' }
};
